import Vue from 'vue';
import format from 'date-fns/format';
import store from '@/store';
import { ExpensesListingActions } from '../expenses-listing/expenses-listing.keys';
import { BatchUpdateListingActions } from '../../../batch-update/batch-update-listing.keys';
import { AdvancedSearchActions } from '../../../advanced-search/advanced-search.keys';

export const expensesListingService = {
  retrieveAssignments: function() {
    return Vue.axios.get('/assignments').then(response => response.data);
  },

  retrieveContractors: function() {
    return Vue.axios.get('/contractors').then(response => response.data);
  },

  retrieveExpenses: function(filters, sortOrder, paginationParameters, searchParam) {
    return Vue.axios
      .get('/expenses', {
        params: {
          ...filters.dateRangeFilters,
          ...filters.statusFilters,
          ...(filters.assignmentId === 0 ? {} : { assignmentId: filters.assignmentId }),
          ...(filters.contractorId === 0 ? {} : { contractorId: filters.contractorId }),
          ...sortOrder,
          ...paginationParameters,
          searchParam
        }
      })
      .then(response => response.data);
  },

  retrieveStatusCounts: function() {
    return Vue.axios.get('/expenses/count-statuses').then(response => response.data);
  },

  retrieveFilteredSortedRecordCount: function(filters, sortOrder, searchParam) {
    return Vue.axios
      .get('/expenses/count-records', {
        params: {
          ...filters.dateRangeFilters,
          ...filters.statusFilters,
          ...(filters.assignmentId === 0 ? {} : { assignmentId: filters.assignmentId }),
          ...(filters.contractorId === 0 ? {} : { contractorId: filters.contractorId }),
          ...sortOrder,
          searchParam
        }
      })
      .then(response => response.data);
  },

  async downloadExpensesXlsx(filters, sortOrder) {
    const response = await Vue.axios({
      url: `/expenses/xlsx`,
      method: 'GET',
      params: {
        ...filters.dateRangeFilters,
        ...filters.statusFilters,
        ...(filters.assignmentId === 0 ? {} : { assignmentId: filters.assignmentId }),
        ...(filters.contractorId === 0 ? {} : { contractorId: filters.contractorId }),
        ...sortOrder
      },
      responseType: 'blob'
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `Expenses-${format(new Date(), 'YYYY-MM-DD-HH-mm-ss')}.xlsx`);
    document.body.appendChild(link);
    link.click();
  },

  async bulkUpdateExpenses(bulkAction, expenseRefs) {
    if (bulkAction.action !== 'PDF') {
      return Vue.axios
        .post('/expenses/bulk-update', {
          bulkAction,
          referenceNumbers: expenseRefs
        })
        .then(response => response.data);
    } else {
      await Vue.axios({
        method: 'post',
        url: '/expenses/bulk-pdf',
        data: {
          bulkAction,
          referenceNumbers: expenseRefs
        }
      }).then(response => {
        store.dispatch(AdvancedSearchActions.SetBatchPdfLoading, false);
        store.dispatch(BatchUpdateListingActions.SetBatchPdfGenerated, false);
        store.dispatch(ExpensesListingActions.SetBatchExpensesList, response.data);
      });
    }
  }
};
